import React from 'react';
import { withTranslations, WithTranslations } from '../../../../utils/withTranslations';
import { TemplatesStore } from '../../../stores/TemplatesStore';
import { injectStoresV1 } from '../../../stores/injectStoresV1';
import { biLogger } from '../../../utils/BILogger';
import { CategoriesStore } from '../../../stores/CategoriesStore';
import s from './SaveTemplateButton.scss';

interface SaveTemplateButtonProps extends WithTranslations {
  dataHook?: string;
  templatesStore: TemplatesStore;
  categoriesStore: CategoriesStore;
}

const SaveTemplateButtonCmp: React.FC<SaveTemplateButtonProps> = ({ t, dataHook, categoriesStore, templatesStore }) => {
  const signInUrl = `https://users.wix.com/signin?view=sign-up&loginCompName=SignUp_H&postLogin=https:%2F%2Fwix.com%2Fwebsite%2Ftemplates&forceRender=true`;

  const handleSaveButtonClick = () => {
    biLogger.logSaveTemplateClick({
      category: categoriesStore.activeCategory?.id ?? '',
      subcategory: categoriesStore.activeSubCategory?.id ?? '',
      page_number: templatesStore.page,
      template_id: templatesStore.expandedTemplate?.id,
    });
  };

  return (
    <a href={signInUrl} className={s.button} data-hook={dataHook} onClick={handleSaveButtonClick}>
      {t('template.newMobileFlow.preview.saveTemplate')}
    </a>
  );
};

export const SaveTemplateButton = withTranslations(
  injectStoresV1('templatesStore', 'categoriesStore')(SaveTemplateButtonCmp),
);
